import React, {useState,useEffect,useContext} from 'react'
import edit from '../images/Icon-Edit.svg'
import moment from 'moment';
import { keyContext } from './KeyContext'
import GrunddataModal from './Modals/GrunddataModal';
import cross from '../images/Icon-Cross.png'
import { DayPicker } from "react-day-picker";
import da from "date-fns/locale/da";
import arrow from '../images/arrow.png'
import close from '../images/close.png'


function GrundData({data, distibutors, bKDMovies}) {
 const {setTitleChanged, showGrunddataModal, titleNotSaved,distributorsName, setDistributorsName, filmBioChanged} = useContext(keyContext)
 const [localPremierDate, setLocalPremierDate] = useState();

 const key = sessionStorage.getItem("key");
 const orgID = sessionStorage.getItem('orgID')
 let org = sessionStorage.getItem('filmOrg') ? sessionStorage.getItem('filmOrg'):sessionStorage.getItem('default-filmID')
 const orgNo = org && org.split(" ")[org.split(" ").length - 1]
 const [titelEdit, setTitelEdit] = useState(false);
 const [editStarted, setEditStarted] = useState(false);
 const [newTitle, setNewTitle] = useState('');
 const [name, setName] = useState();
 const [bkdname, setBkdname] = useState('');
 const [showCalendar, setShowCalendar] = useState(false);
 const [selectedDate, setSelectedDate] = useState();
 const [dateChosen, setDateChosen] = useState(false);
 const [showErrorModal, setShowErrorModal] = useState(false);
 const [errorNo, setErrorNo] = useState();
 const [errorText, setErrorText] = useState()

 useEffect(() => {
    setLocalPremierDate(filmBioChanged === true ? '' : isEmpty(data.localPremiere) === false && data.localPremiere !== null ?   moment(data.localPremiere.premiere || data.localPremiere.Premiere).format('DD-MM-YYYY') : moment(data.openingDate).format('DD-MM-YYYY'))
    setSelectedDate()
 }, [data,setLocalPremierDate,filmBioChanged]);
// console.log(filmBioChanged, 'film bio changed')

//  console.log(localPremierDate, 'local prem date')

// console.log(selectedDate, 'selected date')
// console.log(new Date(localPremierDate))
 const leftMargin = document.getElementById('filmedit').getBoundingClientRect().x
const fullDateFormat = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
//console.log(fullDateFormat, 'date format')
 const disabledDays = [  { from: new Date(2022, 0, 1), to:  moment().subtract(1, 'day').toDate() }  ] ;

  // --------------ERROR MODAL ----------------
  function ErrorModal({shown,children,errorText, errorNo}) {
     
   function handleOkBtn () {
       setShowErrorModal(false)
      //  setFilmSynopsClk(false)
     //  deleteFilmSynops()
   }

  return shown ? (
   <div style={{position:'fixed',display:'flex',justifyContent:'center',top:  '69px',left:leftMargin,width:
    '1440px', backgroundColor:'rgba(0,0,0,0.5)',zIndex:100,overflowY:'auto',height:'100%'}}>
   {children}
 

   <div style={{border:'1px solid white', width: '500px',height:'300px',backgroundColor:'white',padding:'20px',marginTop:'20px',borderRadius:'4px',position:'absolute',top:'20%',left:'50%',transform:'translate(-50%, -50%)'}}>
      <p style={{fontWeight:900}}>Result :  {errorNo}</p>  
      <p style={{fontWeight:900}}>ErrorDescription:</p>
      <p style={{height:'60%',overflow:'auto',border:'1px solid #dee0e3',borderRadius:'4px',padding:'5px',marginTop:'-15px'}}> {errorText}</p> 
    
      <button onClick={handleOkBtn} style={{backgroundColor:'#982f2f',color:'white',padding:'5px',width:'100px',borderRadius:'5px'}}>Ok</button>
   </div>
   </div>
 ) : ''
}

function CalendarModal ({shown,children}) {
   return shown ? (
      <div  className="modal-backdrop"  
         style={{top:'0px',width:'1440px',height:'100%',left:leftMargin,backgroundColor:'rgba(0,0,0,0.7)'}}
       > 
       
       
       </div>
    )
    : ''
}

function premiere_save (obj) {
   fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_premiere_save` ,{
      method: "POST",
     
      headers: {
          'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
          'Content-Type':  'application/x-www-form-urlencoded',
         },
   
     body:`Key=${key}&addingdata=${JSON.stringify(obj)}`
     
  })
  .then(res => res.json())
  .then(result => {
   setDateChosen(false)

   //  console.log(result, 'premier save result')
   if(result.Result !== 1) {
      setShowErrorModal(true)
   }
   else {
      setLocalPremierDate(moment(result.Premiere).format('DD-MM-YYYY'))
      data.localPremiere = result
   }
  })
}

function deletePremiere () {
   let obj = Object.assign({}, data.localPremiere) 
   obj.created = fullDateFormat
   obj.edited = fullDateFormat
   // console.log(obj, 'obj to delete')
   fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_premiere_delete` ,{
      method: "POST",
     
      headers: {
          'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
          'Content-Type':  'application/x-www-form-urlencoded',
         },
   
     body:`Key=${key}&addingdata=${JSON.stringify(obj)}`
     
  })
  .then(res => res.json())
  .then((result) => {
   setDateChosen(false)

   // console.log(result, 'result from delete')
   if(result.Result !== 1) {
      setShowErrorModal(true)
      setErrorNo(result.Result)
      setErrorText(result.ErrorDescription)
   }
   else {
      data.localPremiere = {}
      setLocalPremierDate(moment(data.openingDate).format('DD-MM-YYYY'))
   }
  })
}
// console.log(showGrunddataModal, 'show grunddata modal')

// console.log(distibutors, 'all dist')
// console.log(bKDMovies, 'bkd data')
  useEffect(() => {
    setMonth(selectedDate)
  },[selectedDate])

  const [month, setMonth] = useState(); 

useEffect(() => {
   setName(data.name)
}, [data]);

// -------- finding distributors name-----
useEffect(() => { 
     if(data.distributorNo !== 0){
            distibutors.map((dis) => {
               if(dis.no === data.distributorNo) {
                  // console.log(dis)
                  setDistributorsName(dis.name)
               }
            })
     }
     else setDistributorsName('')
   }, [data, distibutors]);

   //--------- finding BKDfilm name ----------
   useEffect(() => {
      if(data.bKDMovieNo !== 0) {
           bKDMovies.map((bkd) => {
             if(bkd.no === data.bKDMovieNo) {
               setBkdname(bkd.name)
            }
           })
      }
   }, [data,bKDMovies]);
  

//  function allowEdit () {
//    setTitelEdit(true)
   
//  }
//  function handleTitleInput (e) {
//    setTitleNotSaved(false)
//    //   setName(e.target.innerHTML)
//    console.log(e)
//    setEditStarted(true)
//    setNewTitle(e.target.value)
//  }
//  useEffect(() => {
//    if(editStarted === true )
//    setName(newTitle)
//  }, [newTitle]);

 function handleClick() {
   setShowCalendar((current) => !current); 
   
 }
 function closeCalendar() {
   // console.log('date chosen')
   setShowCalendar(false);
   // toggleCalendar();
 }
 

useEffect(() => {
   if(titleNotSaved === true ) {
      setTitelEdit(false)
      setEditStarted(false)
       setName(data.name)
   }
});
useEffect(() => {
   if(titleNotSaved === true && showGrunddataModal === false) {
      //  setTitleChanged(false)
      //  setName(data.name)

   }
}, [titleNotSaved, showGrunddataModal]);
//------------when to ask set Title change to TRUE-------------
useEffect(() => {
   if(editStarted === true && newTitle != data.name ) {
      // console.log(' TITLE CHANGED')
      setTitleChanged(true)
     }
     else setTitleChanged(false)
}, [data,newTitle,titelEdit,editStarted]);


 //-------------function for checking empty array----------
function isEmpty(obj) {
   for (const prop in obj) {
       if (Object.hasOwn(obj, prop)) {
           return false;
       }
   }
   return true; 
 }

 function dayClicked () {
   setShowCalendar(false);
   setDateChosen(true)
   // console.log('date clicked', selectedDate)
 }
 
//  console.log(dateChosen, 'DATE CHOSEN')
   useEffect(() => {
      if(dateChosen === true) {
         // console.log(selectedDate, 'selected date from uef')
         let newDate = moment(selectedDate).format('YYYY-MM-DD')
         if(data.localPremiere) {
            // console.log('already have premier')
            let obj = {
               created  : fullDateFormat,
               createdByLoginNo: orgID,
               edited: fullDateFormat,
               editedByLoginNo:  orgID,
               no :  data.localPremiere.No || data.localPremiere.no,
               orgNo  :  orgNo,
               premiere : newDate,
               sysNo :  3,
               webMovieNo   :  data._no
            }
           
          
               //  console.log(obj,'obj to edit')
               premiere_save(obj)
         }
         else  {

      //  console.log('dont have premiere')
         // console.log(data)
         let obj = {
            created  : fullDateFormat,
            createdByLoginNo: orgID,
            edited: fullDateFormat,
            editedByLoginNo:  orgID,
            no :  0,
            orgNo  :  orgNo,
            premiere : newDate,
            sysNo :  3,
            webMovieNo   :  data._no
         }
         
      //   console.log(obj, 'obj to create')
          premiere_save(obj)
      // }
   }
      }
   }, [selectedDate,dateChosen,data,fullDateFormat,orgID,orgNo]);

  return (
   <>
    {/* <GrunddataModal shown={showGrunddataModal}/> */}
    <ErrorModal  shown={showErrorModal} errorNo={errorNo} errorText={errorText}/>

    <CalendarModal shown={showCalendar}/>
    <div className='grunddataContainer' style={{width:'510px'}}>
        <div style={{position:'relative'}}> 
           <p className='grunddata-title' >Titel</p>
           <div className='gruddata-title-div'  style={{width:'100%',border:titelEdit === true && titleNotSaved !== true  ? '1px solid black':'',}} >
            {/* <input className='grunddata-subtitle' style={{fontWeight:400,width:'100%',border:'none'}} type='text' value={name} onChange={(e) => setName(e.target.value)}  onInput={(e) => handleTitleInput(e)}/> */}
            <p className='grunddata-subtitle' style={{fontWeight:400,padding:'5px 10px'}}>{ name}</p>
            </div> 
           {/* <img onClick={allowEdit} style={{position:'absolute',top:'32px',right:'-28px', cursor:'pointer'}} src={edit} alt='edit' /> */}
        </div>

        <div style={{marginTop:'25px'}}>
           <p className='grunddata-title' >Original titel</p>
           <div className='gruddata-title-div'  style={{width:'100%'}} >
            <p className='grunddata-subtitle' style={{fontWeight:400}}>{isEmpty(data.originalName) === false ? data.originalName : ''}</p></div>
        </div>

        <div  style={{marginTop:'25px',display:'flex',justifyContent:'space-between'}}>
        <div style={{}}>
           <p className='grunddata-title' >Nummer</p>
           <div className='gruddata-title-div'  style={{width:'137px'}} >
           <p className='grunddata-subtitle' style={{fontWeight:400}}>{data._no}</p></div>
        </div>
       
        <div style={{}}>
           <p className='grunddata-title' >Film-ID</p>
           <div className='gruddata-title-div'  style={{width:'300px'}} >
           <p className='grunddata-subtitle' style={{fontWeight:400,overflow:'overlay'}}>
            {isEmpty(data.movieID) === false ? data.movieID : ''}</p></div>
        </div>
        </div>

        <div style={{marginTop:'25px'}}>
           <p className='grunddata-title' >Version</p>
           <div className='gruddata-title-div'  style={{width:''}} >
           <p className='grunddata-subtitle' style={{fontWeight:400}}>
            {isEmpty(data.subName) === false ? data.subName : ''}
            </p></div>
        </div>

        <div style={{marginTop:'25px'}}>
           <p className='grunddata-title' >Land</p>
           <div className='gruddata-title-div'  style={{width:'100%'}} >
            <p className='grunddata-subtitle' style={{fontWeight:400,position:'relative'}}>
              <p style={{position:'absolute',top:'0px',right:'0px'}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="40" viewBox="0 0 44 40" fill="none">
                <rect opacit  y="0.2" y="1" width="1" height="38" fill="#dee0e3"/>
                <path d="M14 17L22.5 25.5L31 17" stroke="#101010" stroke-opacity="0.2"/>
               </svg>
              </p>{isEmpty(data.country) === false ? data.country : ''} </p> 

            </div>
        </div>

        <div  style={{marginTop:'25px',display:'flex',justifyContent:'space-between',position:'relative'}}>
        <div style={{}}>
           <p className='grunddata-title' >Længde (tid)</p>
           <p  className='grunddata-subtitle' style={{width:'137px',border:'1px solid #dee0e3',borderRadius:'4px',height:'40px',}} >{isEmpty(data.length) === false ? data.length : ''}</p>
        </div>
        <div style={{}}>
           <p className='grunddata-title' >Produktionsår</p>
           <p  className='grunddata-subtitle' style={{width:'107px',border:'1px solid #dee0e3',borderRadius:'4px',height:'40px',}} >
            {data.movieYear ? data.movieYear : ''}</p>
        </div>
        <div style={{position:'relative'}}>
           <p className='grunddata-title' >Præmiere-dag</p> 
           
           <p  className='grunddata-subtitle' style={{width:'163px',height:'40px',border:'1px solid #dee0e3',borderRadius:'4px',position:'relative'}} >
            {localPremierDate }
            <p style={{width:'1px', backgroundColor:'#dee0e3',height:'40px',position:'absolute',top:'0px',right:'40px'}}></p>
            <span onClick={handleClick} style={{position:'absolute',right:'10px',cursor:'pointer'}}>
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 20" fill="none">
    <path d="M4 .5a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0v-4zM9 .5a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0v-4zM14 .5a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0v-4z" fill="#46484C"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M17 3H2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM2 2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h15a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z" fill="#46484C"/>
    <path d="M3 7h3v2H3V7zM3 11h3v2H3v-2zM3 15h3v2H3v-2zM8 7h3v2H8V7zM8 11h3v2H8v-2zM8 15h3v2H8v-2zM13 7h3v2h-3V7zM13 11h3v2h-3v-2zM13 15h3v2h-3v-2z" fill="#46484C"/>
     </svg>
            </span>
           </p>
         {
            isEmpty(data.localPremiere) === false ?
            <img onClick={deletePremiere} style={{position:'absolute',top:'32px',right:'-28px', cursor:'pointer'}} src={cross} alt='edit' />
            : ''
         }
        </div>
        
      {showCalendar ? (
        <div style={{left:'160px',top:'69px',zIndex:11}}
          className={showCalendar ? "programCalendar slide-down" : "Calendar slide-up"}
        >
        
          <figure style={{ textAlign: "right" }}>
            <img src={close}
              alt=""
              style={{ cursor: "pointer" }}
              onClick={closeCalendar}
            />
          </figure>
          <div className="weekdays"  >
                            <span className="days">Man</span>
                            <span className="days">Tirs</span>
                            <span className="days">Ons</span>
                            <span className="days">Tors</span>
                            <span className="days">Fre</span>
                            <span className="days">Lør</span>
                            <span className="days">Søn</span>
                          </div>
          <DayPicker
            locale={da} ISOWeek
            mode="single"
            month={month} 
            onMonthChange={setMonth} 
            selected={selectedDate}
            onSelect={setSelectedDate}
            onDayClick={dayClicked}
            disabled={disabledDays}
            showWeekNumber 
            fromYear={2022} toYear={2030}
            captionLayout='dropdown'
            showOutsideDays
            
          />
          
        </div>
      ) : (
        ""
      )}
        </div>

        <div style={{marginTop:'15px'}}>
           <p className='grunddata-title' >Homepage</p>
           <div className='gruddata-title-div'  style={{width:'100%'}} >
           <p className='grunddata-subtitle' style={{fontWeight:400}}>{isEmpty(data.homepage) === false ? data.homepage : ''}</p></div>
        </div>

        <div  style={{marginTop:'25px',display:'flex',justifyContent:'space-between'}}>
        <div style={{}}>
           <p className='grunddata-title' >Censur</p>
           <div className='gruddata-title-div'  style={{width:'228px'}} >
           <p className='grunddata-subtitle' style={{fontWeight:400}}>
            {  
                  isEmpty(data.censoring) === false ?  data.censoring     
                 : ''}</p></div>
        </div>
        <div style={{}}>
           <p className='grunddata-title' >Kort Censur</p>
           <div className='gruddata-title-div'  style={{width:'228px'}} >
           <p className='grunddata-subtitle' style={{fontWeight:400}}>
          {
               isEmpty(data.shortCensoring) === false ?   data.shortCensoring                            
              : ''}
            </p></div>
        </div>
        
        </div>

        <div style={{marginTop:'25px'}}>
           <p className='grunddata-title' >Distributør</p>
           <div className='gruddata-title-div'  style={{width:'100%'}} >
           <p className='grunddata-subtitle' style={{fontWeight:400}}>{distributorsName}</p></div>
        </div>

        <div style={{marginTop:'25px'}}>
           <p className='grunddata-title' >BKD film</p>
           <div className='gruddata-title-div'  style={{width:'100%'}} >
           <p className='grunddata-subtitle' style={{fontWeight:400,position:'relative'}}>
           {bkdname}
           <p style={{position:'absolute',top:'0px',right:'0px'}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="40" viewBox="0 0 44 40" fill="none">
                <rect opacit  y="0.2" y="1" width="1" height="38" fill="#dee0e3"/>
                <path d="M14 17L22.5 25.5L31 17" stroke="#101010" stroke-opacity="0.2"/>
               </svg>
              </p>
            </p></div>
        </div>

        <div style={{marginTop:'25px'}}>
           <p className='grunddata-title' >IMDB-ID</p>
           <div className='gruddata-title-div'  style={{width:'100%'}} >
           <p className='grunddata-subtitle' style={{fontWeight:400}}>
           {typeof(data.iMDb) === 'string' ? data.iMDb : ''}
            </p></div>
        </div>

    </div>
    </>
  )
}

export default GrundData